// extracted by mini-css-extract-plugin
export default {"mainDiv":"BannerSection_mainDiv__ZeZRk","heading":"BannerSection_heading__iausx","para":"BannerSection_para__Amo7y","btnClass":"BannerSection_btnClass__1GBkO"};